// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: NiQ0_jQVtY
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicBrandPerceptionBarChart.module.css"; // plasmic-import: NiQ0_jQVtY/css
import screenshot14PngKvncqgUngVew from "./images/screenshot14Png.png"; // plasmic-import: KvncqgUngVew/picture

createPlasmicElementProxy;

export const PlasmicBrandPerceptionBarChart__VariantProps = new Array();

export const PlasmicBrandPerceptionBarChart__ArgProps = new Array(
  "sentimentBarChart"
);

const $$ = {};

function PlasmicBrandPerceptionBarChart__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__zQ2Ul)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loading={"lazy"}
            src={{
              src: screenshot14PngKvncqgUngVew,
              fullWidth: 617,
              fullHeight: 558,
              aspectRatio: undefined
            }}
          />
        ),

        value: args.sentimentBarChart
      })}
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBrandPerceptionBarChart__ArgProps,
          internalVariantPropNames: PlasmicBrandPerceptionBarChart__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBrandPerceptionBarChart__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBrandPerceptionBarChart";
  } else {
    func.displayName = `PlasmicBrandPerceptionBarChart.${nodeName}`;
  }
  return func;
}

export const PlasmicBrandPerceptionBarChart = Object.assign(
  // Top-level PlasmicBrandPerceptionBarChart renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicBrandPerceptionBarChart
    internalVariantProps: PlasmicBrandPerceptionBarChart__VariantProps,
    internalArgProps: PlasmicBrandPerceptionBarChart__ArgProps
  }
);

export default PlasmicBrandPerceptionBarChart;
/* prettier-ignore-end */
